import { OrderStatus, ErrorCode } from '@triplabo/web/services/types';

export default {
  views: {
    dashboard: {
      title: 'ダッシュボード'
    },
    home: {
      title: 'GO×Triplabo タクシー',
      greeting: 'こんにちは、さあ出発！',
      go: 'GOがサービス提供',
      loginButton: '今すぐログイン',
      destinationPlaceholder: '目的地はどこですか？',
      pickUp: '乗車',
      recommendPickup: 'おすすめ乗車地点',
      recommendDropOff: 'おすすめ降車地点',
      cannotUsePoint: '乗降禁止エリア',
      nowPlace: '現在地',
      nowPlaceJa: '現在地',
      categories: {
        recommend: 'おすすめ',
        transportation: '交通',
        attraction: '観光地',
        experience: '体験'
      },
      viewDetail: '詳細を見る',
      status: {
        finding: {
          title: '車両を呼び出しています',
          subtitle: 'しばらくお待ちください'
        },
        dispatching: {
          subtitle: 'ドライバーがすぐに到着します'
        },
        pickUpArrived: {
          subtitle: 'ドライバーが到着しました。すぐに連絡してください'
        },
        onDeliver: {
          subtitle: '移動中です'
        }
      }
    },
    pickup: {
      title: '乗車地点を選択',
      searchPlaceholder: '乗車地点を入力してください',
      recommendTitle: '近くのおすすめ乗車地点',
      historyTitle: '履歴',
      empty: 'データがありません',
      emptyTip:
        '他のキーワードを試すか、「地図で選択」を使って注文してください',
      emptyButton: '地図で選択',
      deleteConfirm: '本当に削除しますか？',
      deleteConfirmRecall: '確認',
      deleteConfirmCancel: 'キャンセル',
      facilityTag: 'おすすめ'
    },
    pointChange: {
      searchUpPlaceholder: '乗車地点を入力してください',
      searchDownPlaceholder: '降車地点を入力してください',
      title: '乗車地点の変更',
      titleDropOff: '降車地点の変更',
      description: '地図のピンをドラッグして乗車地点を変更できます',
      descriptionDropOff: '地図のピンをドラッグして降車地点を変更できます',
      confirm: '乗車地点を確認',
      confirmDropOff: '降車地点を確認'
    },
    dropOff: {
      title: '降車地点を選択',
      searchPlaceholder: '降車地点を入力してください',
      recommendTitle: '近くのおすすめ降車地点'
    },
    orderConfirm: {
      discountApplied: '割引済み',
      paymentTimeoutDialog: {
        description:
          'システムが混み合っています。カスタマーサービスに連絡して返金をお願いします。',
        subtitle:
          'まずスクリーンショットを保存し、それからカスタマーサービスに連絡してください。',
        goToService: 'カスタマーセンターへ',
        orderIdLabel: '注文番号'
      },
      paymentProcessing: '注文確認中です。閉じないでください。',
      ascfPayConfirm: {
        content: '支払いが完了しましたか？',
        confirm: 'OK',
        notPaid:
          '支払いが確認されませんでした。「マイトリップ」で注文状況をご確認ください。'
      },
      title: '今すぐタクシーを呼んで、すばやく乗車！',
      selectType: '車種を選択',
      normal: 'エコノミータクシー',
      premium: '高級タクシー',
      wagon: '快適タクシー',
      airport: '空港割引定額',
      airportTag: '定額料金',
      airportTip:
        '日本円の固定金額です。実際の金額は当日の決済平均レートで精算されます',
      confirm: '今すぐ呼ぶ',
      time: '約{{min}}～{{max}}分で乗車',
      estimate: '見積もり',
      estimateTag: '見積もり料金',
      discount: '割引済み',
      unit: '円',
      coupon: 'クーポン',
      couponAvailable: '{{count}} 枚利用可能',
      checkOrderFailed:
        '注文状況の確認に失敗しました。しばらくしてから再度お試しください。',
      callWaiting: {
        title: '現在、近くに車がいません。呼び続けますか？',
        subtitle:
          '利用可能な車両を継続して探し、見つかり次第すぐに通知します。',
        confirm: '呼び続ける',
        cancel: 'キャンセル',
        finding: '近くの車両を探しています…',
        dispatching: '車両を手配中です。しばらくお待ちください。',
        continueWaiting: '近くに車両がいません。待ち続けますか？',
        continue: '待ち続ける',
        unwait: '待たない'
      }
    },
    profile: {
      title: 'マイページ',
      order: '私の旅程',
      coupon: 'クーポン',
      service: 'カスタマーセンター',
      userName: 'ユーザー名',
      editProfile: 'プロフィール編集',
      notLogin: '未ログイン',
      goToLogin: 'ログイン',
      logout: 'ログアウト',
      creditCard: 'クレジットカード管理'
    },
    editUserInfo: {
      title: '個人情報の編集',
      name: '氏名（ローマ字）',
      email: '連絡用メールアドレス（電子レシート送付先）',
      phone: '電話番号',
      confirm: '変更を確認',
      emailError: '正しいメールアドレスを入力してください',
      phoneError: '正しい電話番号を入力してください',
      nameError: '正しい氏名を入力してください',
      success: '変更に成功しました',
      error: '変更に失敗しました。後でもう一度お試しください。'
    },
    order: {
      all: 'すべて',
      succeed: '完了',
      pending: '未払い',
      canceled: 'キャンセル',
      empty: '注文がありません',
      emptyTip: 'タクシーを呼びましょう',
      noMore: 'これ以上ありません',
      orderId: '注文番号',
      carType: {
        normal: 'エコノミー',
        premium: '高級',
        wagon: '快適',
        airport: '空港定額',
        any: 'エコノミー'
      },
      status: {
        [OrderStatus.Succeed]: '完了',
        [OrderStatus.Canceled]: 'キャンセル',
        [OrderStatus.Finding]: '呼び出し中',
        [OrderStatus.DispatchFailed]: '呼び出し中',
        [OrderStatus.Dispatching]: '移動中',
        [OrderStatus.PickUpArrived]: '移動中',
        [OrderStatus.OnDeliver]: '移動中',
        [OrderStatus.DropOff]: '完了',
        pending: '未払い'
      },
      money: '{{amount}}'
    },
    payment: {
      title: '前払い料金',
      description:
        'スムーズな配車確保のため、推定料金を先にお支払いください。終了後に差額は精算されます。',
      wechat: 'WeChatペイ',
      wechatDesc: '人民元で支払い、中国大陸のWeChatユーザー向け',
      agreement: '内容をよく読み、同意しました',
      agreementLink: '《前払い契約》',
      confirm: '¥{{amount}} を前払い',
      money: '{{amount}}<span>円</span>',
      support: 'サポート'
    },
    cancelOrder: {
      success: '注文がキャンセルされました',
      confirmCancel: {
        title: '本当にキャンセルしますか？',
        warning:
          'キャンセルには手数料が発生する場合があります。本当にキャンセルしてもよろしいでしょうか？',
        note: '良好な配車環境維持のため、頻繁なキャンセルは制限されることがあります。ご理解とご協力をお願いいたします。',
        viewRules: 'キャンセル規約を見る',
        waitMore: 'もう少し待つ',
        confirm: 'キャンセルする',
        cancelFee: 'キャンセル料',
        cancelFeeDescription: '¥{{amount}}'
      },
      selectReason: {
        title: 'キャンセル理由を選択',
        submit: '送信',
        otherReason: 'その他の理由',
        customReasonPlaceholder: '他に理由があればこちらにご記入ください',
        reasons: {
          platform: {
            title: 'プラットフォーム関連',
            content: {
              tooFar: '配車が遠すぎる',
              inaccurateLocation: '位置情報が不正確／乗車地点が見つからない',
              notExpectedCar: '想定と違う車種'
            }
          },
          driver: {
            title: 'ドライバー関連',
            content: {
              driverNotComing: 'ドライバーが来ない（車が動かない／遠ざかる）',
              driverNotContactable: 'ドライバーに連絡できない／見つからない',
              driverCancel: 'ドライバーからキャンセル依頼',
              driverLate: 'ドライバーが遅刻',
              driverNotMatch: '表示された車両またはドライバーと違う'
            }
          },
          self: {
            title: 'お客様都合',
            content: {
              selfChange: '予定が変わったので今は不要',
              otherPlatform: '他社でタクシーを呼んだ',
              cannotArrive: '乗車地点に間に合わない'
            }
          }
        }
      }
    },
    fareEstimate: {
      title: '料金の目安',
      unit: '円',
      hero: {
        title: '料金の目安について',
        subtitle: '応答が速く、お迎えが早く、コスパが高い'
      },
      fee: {
        title: '料金構成の目安',
        totalLabel: '見積金額',
        approx: '約',
        range: '{{min}}～{{max}}',
        items: {
          transport: '運送料（手数料込み）',
          carTypeFee: '車種料金',
          pickup: '迎車料',
          dispatch: '配車料（遠距離配車等含む）',
          service: 'プラットフォーム手数料',
          regional: '地域振興料',
          peak: 'ピーク時間帯調整',
          etc: '通行料（ETC等含む）',
          coupon: 'クーポン割引'
        },
        notes: {
          estimate:
            '見積料金は実際の交通状況、想定走行距離、所要時間、為替変動などをもとに算出され、変動する場合があります。あくまで参考としてご利用ください。',
          service:
            'プラットフォーム手数料は実際の走行距離に応じて段階的に計算されます。',
          extra:
            '高速道路料金、橋・道路料金など、実際の走行中に発生したその他の追加費用は見積料金に含まれません。最終的な金額は乗車終了後の実際の精算額が適用されます。'
        }
      },
      faq: {
        title: 'よくある質問',
        q: '問',
        a: '答',
        items: {
          why: {
            question: 'なぜ実際の料金が見積料金より高くなるのですか？',
            answer:
              'ご注文前に表示される料金はあくまで見積もりです。実際の料金が見積もりを上回る場合、交通渋滞、途中での停車、高速料金などの追加料金が原因で変動することがあります。'
          },
          extraFee: {
            question: '追加料金はお客様の負担になりますか？',
            answer:
              '走行中に発生した高速料金、橋・道路料金、駐車料金などの追加費用は、実情に応じてお客様のご負担となります。'
          },
          routeChange: {
            question: 'ルート変更は料金に影響しますか？',
            answer:
              '走行中の交通状況やお客様のご要望によりルートが変更された場合、最終的な精算額は実際の走行距離と所要時間に基づいて算出されます。'
          },
          cancelFee: {
            question: '注文をキャンセルすると取消料は発生しますか？',
            answer:
              'ドライバーの受注後、無料キャンセル時間を過ぎた場合や、ドライバーがお迎え地点に到着した後にキャンセルした場合は、規定に従って取消料が発生いたします。'
          }
        }
      }
    },
    orderDetail: {
      empty: 'データがありません',
      serviceProvider: 'GO Inc. がサービスを提供',
      more: {
        title: 'もっと見る',
        orderId: '注文番号:{{orderId}}'
      },
      finding: {
        title: '車両を呼び出しています…',
        estimatedTime: '約{{time}}分以内に応答されます。待ち時間:',
        cancelButton: '注文をキャンセル'
      },
      remaining: '残り',
      minutes: '分',
      meter: 'メートル',
      kilometers: 'キロ',
      canceled: {
        title: '注文はキャンセルされました',
        subtitle: '必要であれば再度ご注文ください',
        provider: 'GO Inc. がサービスを提供',
        customerService: 'お問い合わせ',
        paymentDetail: '前払い詳細',
        recallButton: '再注文',
        backHome: 'ホームページに戻る'
      },
      succeed: {
        title: '移動が終了しました',
        provider: 'GO Inc. がサービスを提供',
        actualPay: '実際支払',
        unit: '円',
        customerService: 'お問い合わせ',
        getInvoice: '領収書',
        drivingFee: '走行料金',
        additionalPaymentAmount: '追加支払い金額',
        prepaid: '決済中',
        discount: '割引金額'
      },
      getInvoice: {
        title: '電子領収書を発行',
        description: '電子領収書はメール添付で送信されます',
        invoiceTitle: '請求書名義',
        invoiceTitlePlaceholder: '請求書名義を入力してください',
        email: 'メールアドレス',
        emailPlaceholder: 'メールアドレスを入力してください',
        emailError: '正しいメールアドレスを入力してください',
        remark: '備考',
        remarkPlaceholder: '備考を入力してください',
        submit: '送信',
        success: '電子領収書をメールで送信しました',
        error: '領収書の送信に失敗しました。後でもう一度お試しください。'
      },
      confirmDialog: {
        noDriver: '近くにドライバーが見つかりません。再度配車しますか？',
        recall: '再配車',
        cancel: '注文をキャンセル',
        driverCancel:
          'ドライバーが注文をキャンセルしました。本注文はキャンセルされ、返金が自動処理され、まもなくウォレットに届きます。',
        driverCancelConfirm: '承知しました'
      },
      rideCode: {
        title: '乗車コード',
        description: 'コードをドライバーに提示してください',
        waitingNumber: '待ち合わせ番号',
        destination: '目的地です'
      },
      receive: {
        cardTitle: '乗車後、乗車コードをドライバーに提示してください',
        viewCode: '乗車コードを見る',
        dispatchingText: 'ドライバーが配車を受諾しました',
        dispatchingDescription: 'ドライバーが乗車地点へ向かっています',
        pickUpArrivedText: 'ドライバーが到着しました',
        pickUpArrivedDescription: 'すぐにドライバーと連絡してください',
        onDeliverText: '目的地に向かっています',
        onDeliverDescription: '走行中です。シートベルトをお締めください',
        message: 'メッセージを送る',
        cancelOrder: '注文をキャンセル',
        shareTrip: '旅程を共有'
      }
    },
    repay: {
      statusText: '注文は支払い待ちです...',
      serviceProvider: 'GO Inc. がサービスを提供',
      service: 'カスタマーセンターへ',
      paidText: '追加支払い',
      unit: '円',
      feeUnit: '{{amount}}',
      repayment: '追加の支払い',
      drivingFee: '走行料金',
      prepaidAmount: '前払い金額'
    },
    repayDetail: {
      title: '前払い詳細',
      prepaymentAmount: '前払い金額',
      actualUsage: '移動後の実際の利用',
      unusedPrepayment: '未使用の前払い金額',
      finishedRefund: '注文完了後、未使用分は元の支払い方法に返金されます',
      unusedPrepaymentRefund:
        '注文キャンセル後、未使用分は元の支払い方法に返金されます',
      paymentReminder: '追加料金を支払ってください',
      additionalFarePaid: '注文完了後、追加料金は支払われました',
      cancelFee: 'キャンセル料',
      insufficientPrepaymentNotice:
        '前払いが実際の費用を下回っている場合、不足分をお支払いいただく必要があります。',
      bankProcessingNote:
        '実際の決済は銀行の反映時間によります。7営業日以内に着金しない場合はカスタマーセンターへご連絡ください。',
      cancelFeeNote:
        '車両手配後、利用者都合で注文がキャンセルされた場合はキャンセル料が発生します。',
      cny: '元',
      unit: 'JPY'
    },
    chat: {
      tips: {
        templateOnly: '下のテンプレートメッセージのみ送信できます',
        translation: 'メッセージは自動的に翻訳されます'
      }
    },
    hotelHome: {
      title: 'タクシーで行く旅',
      wechatScan: {
        title: 'WeChatでスキャン',
        description:
          '携帯でQRコードをスキャンしてミニプログラムにアクセスし、他の製品もご覧ください'
      }
    },
    hotelDropOff: {
      title: '降車地点を選択'
    },
    hotelOrderConfirm: {
      title: '注文を確認',
      unit: 'JPY',
      modify: '変更'
    },
    hotelPayment: {
      title: '前払い料金',
      description: '下のQRコードを携帯でスキャンして支払いを行ってください',
      money: '<span>JPY</span>{{amount}}',
      alertText:
        'スムーズな配車確保のため、推定料金をお支払いください。移動終了後、差額は精算されます。未使用の前払い分は元の支払い方法に返金されます。'
    },
    hotelPrePayTerms: {
      title: '前払い契約',
      headDesc: `「GOx旅日タクシー」（以下「当社」）プラットフォームのユーザーとして登録され、プラットフォームルールに従い、当社の移動サービスをご利用いただく際に前払いが必要となる場合があることを踏まえ、本前払い契約（以下「本契約」）を締結いたします。
本契約の内容をよくお読みいただき、十分にご理解・ご同意の上で本サービスをご利用ください。未成年者は法定代理人の同伴のもとで本契約をお読みいただき、ご同意ください。「同意する」をクリックするか、本サービスをご利用いただくことで、本契約の全内容を読み、理解し、受諾したものとみなされ、関連する義務を履行し、相応する責任を負うことにご同意いただいたものとみなされます。`,
      content: [
        {
          title: '前払い支払いルール',
          content: [
            'タクシーサービスのご利用を便利にするため、前払い方式を提供いたします。移動開始前に、プラットフォームの推定料金に従って料金を前払いしていただく必要があります。',
            '前払い金額は、お客様が選択または予約した移動ニーズに基づいて、プラットフォームで公示された料金ルールに従って推定されます。この前払い金は、実際にサービスをご利用いただいた後、対応する料金の相殺に使用されます。',
            '移動を確認し、前払い金をお支払いいただいた後、注文は正式に有効になります。前払い金をお支払いいただけない場合、注文を提出することも、当社プラットフォーム内のドライバーサービスをご利用することもできません。'
          ]
        },
        {
          title: '前払いの精算と調整',
          content: [
            '前払い金はタクシー注文の支払いのみに使用され、チャージ行為を構成しません。',
            '注文が有効になり、移動が完了した後、システムは実際の費用に基づいて精算し、「多退少補」の原則に従って処理します。',
            '前払い金が実際の費用を超える場合、プラットフォームは移動完了後、元の支払いパスに残高を返金します。具体的な返金時間は銀行または第三者決済機関の処理時間によります。',
            '前払い金が実際の費用の支払いに不十分な場合、お客様は不足分を補足する必要があります。支払いを完了した後でのみ、プラットフォームサービスを継続してご利用いただけます。'
          ]
        },
        {
          title: '注文キャンセルと返金',
          content: [
            '前払い金を支払い、注文を生成した後、お客様の個人的な理由以外（注文が受け入れられない、不可抗力事象などに限定されません）により移動が完了できない場合、プラットフォームは前払い金を全額返金し、返金パスは支払いパスと同じです。',
            '注文生成後に積極的にキャンセルし、「責任あるキャンセル」と認定された場合、プラットフォームは対応する料金ルールに従って料金を控除し、残額を返金します。',
            '返金期限は銀行または第三者決済機関の処理時間によりますが、通常7営業日を超えません。返金に問題が発生した場合、プラットフォームカスタマーサービスにお問い合わせいただければ、決済機関とのコミュニケーション処理を支援いたします。'
          ]
        },
        {
          title: '法律適用と紛争解決',
          content: [
            '本契約は「GOx旅日タクシーユーザー契約」の一部であり、本契約で規定されていない事項はユーザー契約に従います。本契約は、ユーザー契約、プライバシーポリシー、その他の文書とともに、本サービスの法的根拠を構成します。本契約が他の関連文書と競合する場合、本契約が優先されます。',
            '本契約は日本法の適用を受けます。本契約から紛争が発生した場合、双方は友好的な交渉を通じて解決すべきです。交渉が失敗した場合、管轄権を有する裁判所に提出して裁定を求めることができます。'
          ]
        },
        {
          title: 'その他の条項',
          content: [
            '本契約のいずれかの条項がいつでも違法、無効、または適用不可能と認定されたが、全体的な契約の有効性に影響しない場合、他の条項は有効のままです。当社は関連する条項を合理的に調整し、適用される法律に準拠させる権利を有します。',
            '当社は本契約の最終解釈権を留保し、業務ニーズに応じて適時に契約内容を改訂する権利を有します。改訂された契約はプラットフォームで公示され、ユーザーがサービスを継続して使用することは改訂された契約の受諾とみなされます。'
          ]
        }
      ]
    },
    hotelPayResult: {
      success: {
        title: '支払い成功',
        description: 'リダイレクト中'
      },
      fail: {
        title: '支払い失敗',
        subtitle: '再度注文をお試しください',
        description: 'ネットワーク、銀行カード残高などが正常かご確認ください',
        btnText: 'タクシーページに戻る',
        seconds: '{{amount}}s'
      }
    },
    hotelOrderDetail: {
      requestSuccess: 'タクシーを呼び出しました'
    },
    login: {
      title: 'ログイン/登録',
      content: {
        title: 'ログイン/メンバー登録の方法を選択してください',
        description:
          '*サードパーティアカウントで簡単にログイン・メンバー登録ができます',
        agreement:
          '*メールまたはサードパーティアカウントでログインする場合、関連する<terms>{{terms}}</terms>と<privacy>{{privacy}}</privacy>',
        terms: '利用規約',
        privacy: 'プライバシーポリシー'
      },
      button: {
        google: 'Google',
        email: 'Email',
        nextStep: '次へ',
        signIn: '新規登録'
      },
      email: {
        label: 'メールアドレス'
      }
    },
    couponList: {
      title: 'クーポン',
      tabs: {
        inputCode: 'クーポンコードを入力',
        shareCoupon: 'クーポンコードを共有'
      },
      inputPlaceholder: 'クーポンコードを入力してください',
      condition: '総予想料金がJPY{{amount}}を超える場合に利用可能',
      applyTo: 'プレミアムタクシーに適用',
      validUntil: '有効期限',
      minSpend: 'JPY{{amount}}以上で利用可能',
      maxDiscount: '最大JPY{{amount}}割引',
      noMinSpend: '最低利用金額なし',
      useButton: '使用する',
      validDate: '{{start}}から{{end}}まで使用可能',
      empty: 'クーポンがありません',
      emptyTip: 'クーポンを取得しましょう',
      couponType: {
        NEW_USER: '新規ユーザー割引クーポン',
        SHARE: '共有クーポン',
        SHARE_REWARD: '共有リワードクーポン',
        BUNDLE: 'バンドルクーポン',
        PROMOTION: '期間限定クーポン',
        AIRPORT_COUPON: '空港定額割引クーポン',
        UNKNOWN_COUPON_TYPE: '不明クーポン'
      }
    },
    showDialog: {
      title: '招待コードをシェアして、特典をゲット！',
      description:
        'お友達招待クーポンは「クーポン確認」をクリックして、招待・交換で<span>高額クーポン</span>をゲット',
      rideButton: '今すぐ乗車',
      shareButton: '招待コードをシェア'
    },
    shareCoupon: {
      title: '招待コードをシェア',
      headline: '友達を招待して乗車割引を一緒に楽しもう！',
      description:
        '友達を招待して登録に成功すると、友達は9.5割引クーポン（最大500円まで）を獲得できます。初回乗車完了後、あなたは200円クーポン（7日間有効）を獲得できます。招待回数に制限はありません',
      description2:
        'お友達があなた専用のクーポンコードを入力すると、お友達は<span>2000円割引クーポン</span>を獲得できます。お友達が乗車後、あなたも<span>1000円割引クーポン</span>を獲得できます！自動的にクーポンパッケージに配布され、受取後15日間有効です。何人でも招待可能、お友達と一緒にGO！',
      campaignDate:
        '（キャンペーン期間は2026年10月12日まで、先着2000名様限定）',
      linkLabel: '招待リンク',
      inviteCodeLabel: '専用招待コード',
      copyButton: 'コピー',
      copySuccess: 'コピー成功',
      copyFailed: 'コピー失敗'
    },
    redeemCoupon: {
      title: 'クーポンコードを入力',
      codeLabel: 'クーポンコード',
      placeholder: 'クーポンコードを入力してください',
      confirmButton: '確認して交換',
      instruction1:
        '*クーポン交換コードを入力し、【確認して交換】をクリックして交換を完了してください;',
      instruction2:
        '*各交換コードは1回のみ成功に交換できます。交換成功後、有効期限内にご使用ください。期限切れの場合は無効になります。',
      emptyCode: 'クーポンコードを入力してください',
      redeemSuccess: '交換成功',
      redeemFailed: '交換に失敗しました。しばらくしてからもう一度お試しください'
    },
    getCoupon: {
      title: 'クーポンを取得',
      coupon: {
        title: '新規ユーザー割引クーポン',
        validity: '有効期限: {{validity}}まで',
        discount: '{{value}}%<unit>割引</unit>',
        minimumSpend: 'JPY{{amount}}以上で利用可能',
        usageCondition: '行程の総予想料金がJPY{{amount}}を超える場合に利用可能'
      },
      button: {
        claim: '今すぐ取得'
      },
      terms: {
        itema: '*初回登録でまだタクシーを利用していないユーザーが取得できます',
        itemb:
          '*ログイン後にのみ取得可能です。期限切れまたは未ログインの場合は取得できません。スキャンごとに1回のみ取得機会があります',
        itemc: '*取得成功後、「マイクーポン」に入って確認・使用できます',
        itemd: '*7日以内に使用する必要があり、期限切れ後は無効になります'
      },
      success: {
        title: '取得成功',
        description:
          'クーポンが正常にクーポンウォレットに追加されました。マイクーポンウォレットに入って確認・使用できます',
        viewButton: 'クーポンを確認',
        gotItButton: '了解しました'
      },
      newComer: {
        title: 'おめでとうございます！特典をゲット！',
        description:
          '友達招待クーポンは「クーポン確認」をタップして、招待コードを共有するか、クーポンコードを入力して交換してください。',
        rideButton: '今すぐ乗車',
        viewButton: 'クーポンを確認',
        coupon: {
          discountUnit: '{{value}}%<unit>割引</unit>',
          jpyUnit: '<unit>JPY</unit>{{value}}',
          maxDiscount: '最大{{amount}}円割引',
          validity: '有効期限: {{validity}}まで'
        }
      }
    },
    signIn: {
      register: '新規登録',
      login: 'ログイン',
      email: {
        label: 'メールアドレス'
      },
      password: {
        label: 'パスワード'
      },
      button: {
        register: '新規登録',
        signIn: 'ログイン'
      },
      forgetPassword: 'パスワードを忘れた方？',
      validate: {
        email: {
          invalid: '正しいメールアドレスを入力してください'
        },
        password: {
          required: 'パスワードを入力してください'
        }
      }
    },
    reset: {
      title: 'パスワードをリセット',
      email: {
        label: 'メールアドレス'
      },
      button: {
        reset: 'メールでパスワードをリセット',
        backToSignIn: 'ログインに戻る'
      },
      sendResetEmailSuccess:
        'パスワード再設定用のURLが <email>{{email}}</email> に送信されます、ご確認のうえパスワードをリセットしてください。'
    },
    terms: {
      name: 'Terms of Use',
      title: 'LINKTIVITY Terms of Use',
      lastUpdated: 'Last Updated: May 1, 2020',
      subtitle: `LINKTIVITY Terms of Use
LINKTIVITY Corporation (hereinafter referred to as "our company") has established the following LINKTIVITY Terms of Use (hereinafter referred to as "this agreement") for the use of LINKTIVITY services.

By using LINKTIVITY services, you acknowledge that you have agreed to accept the contents of this agreement. Please read this agreement carefully when using LINKTIVITY services. Additionally, this agreement may be modified as needed, so please refer to the latest content when using LINKTIVITY services.

* For information regarding the handling of personal information, please read the "Personal Information Protection Policy."`,
      content: [
        {
          title: 'Article 1 Purpose',
          content:
            'This agreement applies to users of the services of "LINKTIVITY," a platform sales website for venue rentals operated by our company. Users of this service must agree to this agreement in advance and use this service based on compliance with this agreement. This agreement may also be modified without prior notice.'
        },
        {
          title: 'Article 2 Member Registration',
          content: `1. "Member" refers to an individual who has been approved by our company to become a member. Such individual, upon agreeing to this agreement, accepting and completing the member registration procedures specified by our company, obtains this service according to these terms. However, even after approval, if our company deems the member inappropriate, approval may be revoked.
2. Information provided during member registration should be true, accurate, and valid. Individual, registration information (such as name, email address, etc.), and passwords should correspond one-to-one, and the same person should not register multiple member identities.
3. If registration information changes, members must immediately perform the prescribed change procedures.`
        },
        {
          title: 'Article 3 Information Provided by Product Suppliers',
          content:
            'Our company provides members with content, fees, available purchase dates, cancellation provisions (cancellation policies), and other purchase-related information (hereinafter referred to as "purchase-related information") provided by product suppliers on LINKTIVITY, as well as product supplier-related information. Purchase-related information is the responsibility of product suppliers, and unless our company fails to transmit information due to intentional acts or negligence, our company bears no responsibility for the content of purchase-related information.'
        },
        {
          title: 'Article 4 Contract Formation',
          content:
            'On the LINKTIVITY platform, contracts related to products purchased and services provided by members will be concluded between members and product suppliers. Posting products, services, and other content on LINKTIVITY is only for the purpose of submitting applications to product suppliers, and our company has the right to freely approve or reject such applications on behalf of product suppliers. This agreement stipulates the conditions for members to use LINKTIVITY services, including cases where members submit purchase applications to product suppliers using LINKTIVITY. However, member reservations for products and services must follow the contract conditions displayed by LINKTIVITY, information provided during the reservation process, and conditions stipulated by legal contracts related to products and services as stipulated by product suppliers.'
        },
        {
          title: 'Article 5 Fee Payment',
          content: `LINKTIVITY, as a collection agent for product suppliers, obtains payment information from members and processes payments. Members should pay fees to our company through credit cards or payment methods provided by our company when purchasing products and services. If expressed in foreign currency, our company will convert the credit card payment amount or settlement amount of payment methods provided by our company to yen according to the determined exchange rate.

However, some payments should be made through one or more methods specified on the page.`
        },
        {
          title:
            'Article 6 Content and Quality of Products and Services Provided by Product Suppliers',
          content:
            'Our company is not responsible for the content and quality of products and services provided by product suppliers. Any problems, disputes, or complaints arising between members and product suppliers, as well as any losses suffered by members, should be resolved through consultation with product suppliers, and our company bears no responsibility for this.'
        },
        {
          title: 'Article 7 Usage Environment',
          content: `1. When using LINKTIVITY, members should prepare necessary communication equipment, software, communication means, and other products and services on their own, and bear full responsibility and costs incurred during the period.
2. When using LINKTIVITY, members should prepare necessary smartphones, software, communication means, and other products and services that can connect to the network on their own, and bear full responsibility and costs incurred during the period.`
        },
        {
          title:
            'Article 8 Order Cancellation and Cancellation Fees Due to Member Reasons',
          content: `1. Cancellation fees incurred when members cancel orders due to their own reasons will be charged according to the cancellation terms (cancellation policies) stipulated by product suppliers.
2. Our company bears no responsibility for foreign exchange gains and losses caused during payment and refund.
3. In principle, members need to log into the "Personal Page" of LINKTIVITY and cancel reservations. However, if they contact product suppliers before the usage date and product suppliers accept order cancellation, cancellation procedures can be completed by notifying LINKTIVITY through the "Personal Page" later.`
        },
        {
          title:
            'Article 9 Order Cancellation and Refunds Due to Product Suppliers',
          content:
            'When product suppliers change or cancel products and services, they should directly notify members, and our company bears no responsibility for changes or cancellations of products and services. However, according to decisions or requirements of product suppliers, if the content of sold products or services changes or is cancelled, our company may handle refunds for products or services on their behalf.'
        },
        {
          title: 'Article 10 Password Management',
          content: `1. Members are responsible for and should manage passwords.
2. Members should not provide email addresses and passwords to third parties for use, and should not lend, transfer, rename, sell, mortgage, etc.
3. Damage liability caused by improper password management, usage errors, or third-party usage by members is borne by members themselves, and our company bears no responsibility.`
        },
        {
          title: 'Article 11 Handling of Member Registration Information',
          content: `1. During member registration, personal information provided by members (hereinafter referred to as "registration information") will be managed and stored by our company according to our company's personal information protection policy.
2. Our company will not disclose to third parties information containing personally identifiable information (hereinafter referred to as "personal information"). However, the following cases are excluded:

   i. When disclosing information with customer consent

   ii. When providing personal information necessary for service performance to business outsourcing companies that have signed personal information protection confidentiality agreements

   iii. When conducting statistical analysis of personal information for service improvement and disclosing or providing to third parties in a state where personal identity cannot be identified or determined

   iv. When disclosure is required according to search warrants issued by courts or court judgments

Additionally, please read the "Personal Information Protection Policy" to understand the personal information obtained by our company, usage purposes, and processing details.`
        },
        {
          title: 'Article 12 Prohibited Items for Members',
          content: `When using LINKTIVITY, members should not engage in the following behaviors or behaviors that may lead to the following:

1. Behaviors that violate this agreement
2. Behaviors that violate public order and morals or laws and regulations
3. Behaviors that infringe on copyrights, portrait rights, or other intellectual property rights of our company, other members, or third parties
4. Behaviors that defame or slander other members or third parties
5. Behaviors that bring adverse effects to other members or third parties
6. Behaviors that interfere with our company's business or hinder our company's service operations
7. Profit-making behaviors
8. Behaviors of transferring or lending rights obtained as members to third parties without prior consent of our company
9. Other behaviors that our company deems inappropriate`
        },
        {
          title:
            'Article 13 Deletion or Correction of Information Sent by Members',
          content: `Our company may delete part or all of the information sent by members that conforms to or may belong to any of the following items, or make any corrections that our company deems necessary, without member consent:

1. Information that our company deems to conform to the "Member Prohibited Items" of this agreement
2. Information that our company judges to be inconsistent with facts
3. Other situations that our company deems inappropriate`
        },
        {
          title: 'Article 14 Cancellation of Member Status',
          content: `If members fall under any of the following situations, our company may cancel member status without prior notice to members, and bears no responsibility to members:

1. One of the situations that violate the "Member Prohibited Items" of this agreement
2. Other violations of this agreement
3. Other situations where our company deems the member unsuitable for member status`
        },
        {
          title: 'Article 15 Service Changes, Suspension, and Termination',
          content: `1. Our company may change, suspend, or terminate service content without prior notice to members.
2. When any disadvantages or losses are caused to members due to changes, suspension, or termination of this service content, our company bears no responsibility.
3. Our company may notify members one month in advance and terminate service provision.`
        },
        {
          title: 'Article 16 Copyright and Property Rights',
          content:
            'All content displayed on LINKTIVITY is copyrighted and owned by our company and individuals or entities such as product suppliers, partners, and advertisers who provide such content to our company. Unless prior written consent is obtained from our company, product suppliers, partners, and advertisers, users and members agree not to copy, disclose, transfer, lend, translate, reprint, transmit, use, or reuse such content. Additionally, our company has the right to claim compensation from users and members for amounts equivalent to benefits obtained during the above-mentioned behaviors.'
        },
        {
          title: 'Article 17 Disclaimer and Liability Limitation',
          content: `1. Our company bears no responsibility for any damages occurring between our company and product suppliers, any damages caused by members violating this agreement, or damages caused by non-company reasons during product or service exchange processes.
2. Product suppliers are independent contract entities from our company. Our company bears no responsibility for any damages or other damages caused by injuries, deaths, property losses, theft, or terrorist attacks when members participate in product activities or enjoy services due to behaviors, negligence, omissions, agency behaviors, guarantees, etc. of product suppliers.
3. Our company bears no responsibility for events such as delays, cancellations, duplicate purchases, strikes, etc. of products or services beyond our company's direct management scope. Additionally, when content changes, cancellations, delays, additional costs, etc. occur due to government agencies, court orders, etc., our company bears no response obligations.
4. When our company provides this service, if members directly or indirectly suffer losses beyond actual, ordinary losses, even if our company has intentional or negligent acts, our company bears no responsibility.`
        },
        {
          title: 'Article 18 Changes to This Agreement',
          content:
            'Our company reserves the right to change the content of this agreement when necessary. When modifying this agreement, changes are considered completed by simply making modifications on this page, and members will not be notified individually.'
        },
        {
          title: 'Article 19 Jurisdiction',
          content:
            'For any disputes regarding this agreement, the Tokyo District Court will be the exclusive court of first instance.'
        },
        {
          title: 'Article 20 Consultation',
          content:
            'For matters not stipulated in this agreement or any questions about this agreement, both parties should negotiate in good faith and make friendly efforts to find solutions together.'
        },
        {
          title:
            '* This is a translated version, the original text shall prevail.',
          content: ''
        }
      ]
    },
    privacy: {
      title: 'プライバシーポリシー',
      lastUpdated: '最終更新日: 2022年3月18日',
      company: 'リンクティビティ株式会社',
      contentTitle: '個人情報保護方針',
      subTitle:
        '当社は、当社の運営する予約サイトLINKTIVITY等において、お客様から個人情報を取得しております。当社は、お客様が安心かつ便利に予約ができるようにするために、お客様の個人情報を保護することは非常に重要なことであると考えており、 以下に記載する事項を遵守して個人情報を取り扱っております',
      content: [
        {
          title: 'お客様の個人データの管理者',
          content:
            'リンクティビティ株式会社\n〒100-0011 東京都千代田区内幸町2-1-6 日比谷パークフロント 19F'
        },
        {
          title: '取得の場面',
          content:
            '当社は、法令により必要とされる場合にはお客様から同意を得た上で、当社の利用目的の達成に必要最低限の個人情報を取得します。'
        },
        {
          title: '利用の場面',
          content:
            '当社は、当社の定める利用目的の達成のためにのみ、お客様から取得した個人情報を利用いたします。'
        },
        {
          title: '保管・保存の場面',
          content:
            '当社は、お客様から取得した個人情報が外部に漏洩することのないよう、システムセキュリティに留意して個人情報の保管・保存等を行っています。'
        },
        {
          title: '破棄・消去の場面',
          content:
            '当社は、利用する必要がなくなった個人データ（個人情報の保護に関する法律に定める個人データを意味します。以下同じです。）は、必要がなくなった時点で、遅滞なく破棄します。'
        },
        {
          title: 'お客様からのお問い合わせ等への対応',
          content:
            '当社は、お客様からの保有個人データ（個人情報の保護に関する法律に定める保有個人データを意味します。以下同じです。）の利用目的通知の求め、開示請求、訂正・追加・削除請求、利用停止・消去請求及び第三者提供の停止請求に対し、法令に従い対応いたします。'
        },
        {
          title: '安全管理措置等',
          content:
            '当社は、LINKTIVITYサービスに関係する全てのスタッフが、個人情報の重要性を理解できるよう教育を行うほか、個人情報の安全管理のために必要かつ適切な措置を講じています。'
        }
      ],
      rules: [
        {
          title: '当社が取得する個人情報と利用目的について',
          subtitle:
            '当社は、以下に掲げる利用目的で、お客様のご住所、ご氏名、生年月日、ご連絡先、メールアドレス又は旅券番号等の個人情報を取得し、利用いたします。また、当社は、お客様の同意なく要配慮個人情報を取得いたしません。なお、お客様の個人情報の取得にあたり、個人情報の利用目的が公表されていない場合には、かかる取得の対象となった個人情報の利用目的を、お客様に通知し、又は公表するものとします。また、当社は、保護者の同意なく13歳以下の児童から個人情報を取得しません。13歳以下の児童の個人情報を提供いただく場合、保護者の同意を取得いただいているものとして取り扱いますが、同意がないことが明らかになった場合には、保護者への連絡その他これに付随する目的以外に当該個人情報を利用しません。',
          rule: [
            {
              title: 'LINKTIVITYサービス利用（会員登録等）のため',
              content:
                'LINKTIVITYサービス利用のため、お客様の個人情報を当社内部で共有します。\n法的根拠：お客様の要求するサービスや機能を提供するために必要となります。'
            },
            {
              title: 'チケット購入のお申込みのため',
              list: [
                {
                  title: '取得する個人情報の項目',
                  content:
                    '当社は、お客様からの商品提供者からのチケット購入の申込み等に際して、お客様のご氏名や、決済情報、旅券番号のほか、健康状態や病歴等といったお客様の健康状態に関する情報等を取得いたします。'
                },
                {
                  title: '具体的な利用目的',
                  content:
                    '当社は、お客様の商品提供者からのチケット購入資格の確認やチケットの代金等の決済のためにお客様の個人情報を取得し、利用いたします。また、かかる目的のために、商品提供者、交通機関、代金決済事業者等（海外の事業者等を含みます。）へお客様の個人情報を提供いたします。'
                }
              ],
              subtitle:
                '法的根拠：お客様の要求するサービスや機能を提供するために必要となります。'
            },
            {
              title:
                'ニュースレター（メールマガジン等）の送付等、お客様へのご案内の送付のため',
              content: '法的根拠：お客様からの同意に基づき収集します。'
            },
            {
              title:
                'ソーシャルメディアや広告配信プラットフォームを通じた広告のため',
              content: '法的根拠：お客様からの同意に基づき収集します。'
            },
            {
              title: 'アンケートへのご記入のお願いのため',
              content:
                '法的根拠：当社の予約サイト、商品やサービス等の改善のためお客様の同意に基づき収集します。'
            },
            {
              title: 'お客様情報の解析及び管理のため',
              content:
                '法的根拠：当社の予約サイト、商品やサービス等の改善することにより、お客様の正当な利益を追求・保護するために必要となります。'
            },
            {
              title: 'クレジットカード等の不正利用の検知のため',
              content:
                '法的根拠：お客様のクレジットカードの安全性を確保し、お客様の正当な利益を追求するために必要となります。'
            }
          ]
        },
        {
          title: '個人データの第三者提供について',
          subtitle:
            '当社は、以下のいずれかの場合を除き、お客様から取得した個人データを第三者に提供いたしません。\n\nお客様から第三者（商品提供者、海外の旅行業者、ソーシャルメディア事業者、広告配信サービス会社等の事業者を含みます。）への個人データの提供について、本プライバシーポリシーに同意いただく方法その他の方法により、事前にご同意をいただいた場合\n上記の利用目的の達成に必要な範囲内において個人データの取扱を外部委託した場合\n法令に基づき提供を求められた場合\n人の生命、身体又は財産の保護のために必要な場合であって、お客様の同意を得ることが困難である場合\n公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、お客様の同意を得ることが困難である場合\n国又は地方公共団体などが法令に定める事務を実施する上で、協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合',
          rule: []
        },
        {
          title: '個人データの取扱の委託について',
          subtitle:
            '当社は、前項に基づき当社の利用目的の達成に必要な範囲内で第三者にお客様の個人データの取扱いを委託する場合、委託先に対して必要かつ適切な監督を行います。また、委託先が再委託を行う場合には、当社は、委託先が再委託先に対して、必要かつ適切な監督を行っているか否かを直接又は関接に監督いたします。再委託先が再々委託する場合についても同様とします。',
          rule: []
        },
        {
          title: 'Cookie情報等の取得について',
          rule: [
            {
              title: 'クッキー（Cookie）',
              content:
                'クッキーとは、お客様（ユーザー）についての情報を含む、ユーザーのハードドライブに蓄えられるデータのひとつです。当社では、クッキーを、個人を特定する情報として利用することはありません。また、セッションクッキーですので、一旦ユーザーがそのブラウザを閉じますと、クッキーは保存されません。 クッキーは、お客様へのサービス向上、当社サイトのカスタマイズ・広告の効果の測定等の目的で利用します。\n\nまた、当社は、統計処理データとしてクッキーを分析することによって、お客様のご興味やご関心の高い事項を探知し、それらを活用しているほか、 不正アクセス防止のためにも利用しております。\n\nクッキーは、お客様のご希望に応じて無効化することができますが、それにより、お客様はLINKTIVITYでのご予約ができなくなります。'
            },
            {
              title: 'ログ・ファイル',
              content:
                '当社では、特定の情報を自動的に収集してログ・ファイルに保存しています。 この特定の情報には、IP（インターネットプロトコル）アドレス、ブラウザの種類、ISP（インターネットサービスプロバイダ）、参照/終了ページ、オペレーティングシステム、日付/ タイムスタンプが含まれます。 当社は、これらの情報を、不正アクセスを監視する目的で利用しております。 また、当社は、お客様の傾向分析や、サイト管理、サイトにおけるお客様の動向追跡を行っています。\n\nただし、当社は、これらの情報を、特定の個人を識別できないようにして利用しており、取得した情報を上記以外の目的で利用することはありません。'
            },
            {
              title: 'ウェブビーコンについて',
              content:
                '当社では、ウェブビーコンを、アクセス解析及びアフィリエイトプログラムのために利用しています。 当社は、ウェブビーコンについて、上記以外の目的での利用や、特定の個人を識別するための利用はしておりません。'
            },
            {
              title: '統計的分析について',
              content:
                '当社では、どのサイトやサービスの人気が高いかを確認するために、 第三者アクセス解析ツールを利用し、LINKTIVITYサイト内でお客様がアクセスしたページや、ページの履歴を記録しています。\n\n当社は、これらのデータを、特定の分野にご興味を示されたお客様に対して、LINKTIVITY内で、その興味に合わせたコンテンツや広告を提供するために使用しています。\n\nまた、個人を特定しない統計情報を収集することもあります。さらに、第三者アクセス解析ツール上にて当社が収集したクッキー情報と他社が収集したクッキー情報を双方で閲覧可能にすることもあります。'
            }
          ]
        },
        {
          title: '匿名加工情報の取扱いついて',
          rule: [
            {
              title: '匿名加工情報の作成',
              content:
                '当社は、匿名加工情報を作成する場合には、以下の対応を行います。 匿名加工情報とは、法令の定めによる措置を講じて特定の個人を識別することができないように個人情報を加工して得られる個人に関する情報であって、当該個人情報を復元することができないようにしたものをいいます。\n\n①法令で定める基準に従い、適正に加工すること\n②法令で定める基準に従い、削除した情報や加工の方法に関する情報の漏えいを防止するために安全管理措置を講じること\n③作成した匿名加工情報に含まれる情報の項目を公表すること\n④作成に用いられた個人情報に係る本人を識別するための行為をしないこと'
            },
            {
              title: '匿名加工情報の提供',
              content:
                '匿名加工情報を第三者に提供する場合には、提供しようとする匿名加工情報に含まれる個人に関する情報の項目と提供の方法を公表するとともに、提供先となる第三者に対して、提供する情報が匿名加工情報であることを明示します。'
            },
            {
              title: '匿名加工情報に関する公表',
              content:
                '匿名加工情報の作成について\n当社が保有する以下のお客様の個人情報について、当社は、特定の個人を識別すること及び個人情報を復元することができないよう適切な措置を講じたうえで匿名加工情報として継続的に作成いたします。\n\n匿名加工情報に含まれる個人に関する情報の項目\nプラットフォームサービスの提供に関して取得した情報\n購入日、参加日、バウチャーの言語、販売金額のレンジ、参加人数、予約の状態（予約確定かキャンセル等）、サプライヤーの所在地域及び県情報、旅行会社の所在国\n\n匿名加工情報の第三者提供について\n当社が作成または保有する匿名加工情報について、当該情報が匿名加工情報であることを明示したうえで、継続的に第三者に提供いたします。\n\n匿名加工情報に含まれる個人に関する情報の項目\n上記「匿名加工情報の作成について」における「匿名加工情報に含まれる個人に関する情報の項目」と同一の項目\n\n提供の方法\nパスワードにより保護された電子ファイルを電子的な通信手段（電子メール、サーバーにアップロード、API連携等）、またはDVD等の物理媒体により送付'
            }
          ]
        },
        {
          title: '個人データの安全管理措置について',
          subtitle:
            '個人データの漏えい、盗用、悪用、不正アクセス、改ざん及び破壊等を防ぐために、組織的、技術的、物理的な安全管理措置を講じています。当社が個人データを保存するサーバーへのアクセスは、ID／PWを有する特定の従業員のみに制限されており、中でも一部の個人データの管理については、データの管理等に必要最小限の従業員にのみアクセスを付与しています。\n\n更にクレジットカード情報を含む個人データについては、複数のデータセンターに分散してセキュアな環境において保管しています。また、当社は、予約取引に関するすべてのページでSecure Sockets Layer（SSL）暗号を使用しています。 SSL対応ブラウザの使用により、インターネット上で送信する個人データとクレジットカード情報の機密性を保持することができます。\n\nまた、お客様の個人データを取り扱う当社の従業員は、端末を離れるときにはパスワードで保護されたスクリーンセーバーを使用しております。\n\nさらに､当社は、部署によっては毎月1回、全社的には半年に1回以上の頻度で、個人情報の重要性等に関する教育研修を実施しております。また、教育に関する記録もとっております。',
          rule: []
        },
        {
          title: 'お客様の個人データの取扱いに関する権利について',
          subtitle:
            '2016年4月27日付のEU一般データ保護規則（GDPR）2016/679に基づき、個人データの処理に関し、お客様は以下の権利があります。',
          rule: [
            {
              title: 'アクセス権'
            },
            {
              title: '訂正権'
            },
            {
              title: '削除権（忘れられる権利）と処理を制限する権利'
            },
            {
              title: 'データポータビリティー権'
            },
            {
              title: '異議を述べる権利'
            },
            {
              title:
                'プロファイリングを含む自動処理に基づく決定に服されない権利。'
            }
          ]
        },
        {
          title: '開示・訂正・利用停止等の請求等について',
          subtitle:
            '当社は、お客様からの保有個人データの利用目的通知の求め、開示請求、訂正・追加・削除請求、利用停止・消去請求又は第三者提供の停止請求（以下、総称して「開示等の請求等」といいます。）に対しては、下記11記載の連絡窓口にて対応いたします。\n\nまた、当社は、お客様のマイページにおいて、会員情報の変更及び確認並びにメールマガジンの配信停止等のご希望に応じることとしております。',
          rule: []
        },
        {
          title: '外部へのリンクについて',
          subtitle:
            'LINKTIVITYホームページには、他のサイトへのリンクが含まれています。 本プライバシーポリシーは、LINKTIVITYホームページによって収集される情報だけに適用され、その他のウェブサイトのプライバシーポリシーまたはコンテンツについて、当社は責任を負いません。お客様におかれましては、リンク先の各ウェブサイトで、プライバシーポリシーをお読みいただき、お客様の個人情報の取扱いについてご確認いただきますようお願い申し上げます。',
          rule: []
        },
        {
          title: 'プライバシーポリシーの変更について',
          subtitle:
            '当社は、プライバシーポリシーをLINKTIVITYホームページ上に掲載し、当社がお客様のどのような個人情報をどのような目的で取得し、利用しているか、お客様が常に知ることができる状態にしています。また、プライバシーポリシーの変更についても、LINKTIVITYホームページ上に掲載し、お客様に公表しております。',
          rule: []
        },
        {
          title: '連絡先について',
          subtitle:
            '当社のプライバシーポリシーや、当社の個人情報保護への取り組み、お客様の個人情報の取得、利用等に関するご質問又は開示等の請求等については、下記のお問い合わせフォームをご利用ください。担当者より5営業日以内に返答させていただきます。\n\nリンクティビティ株式会社\n〒100-0011 東京都千代田区内幸町2-1-6 日比谷パークフロント 19F\n\nデータ保護責任者の連絡先 dpo@linktivity.co.jp',
          rule: []
        }
      ]
    },
    service: {
      title: 'ヘルプセンター',
      categories: {
        fee: '料金について',
        driver: '運転手について',
        other: 'その他'
      },
      items: {
        fee: {
          estimatedCost: {
            label: '予想料金',
            content:
              '予想料金は、行程のおおよその費用を把握するのに役立ちます。乗車地と降車地を入力した後、次のページで予想料金が表示されます。予想料金は最短ルートと予想走行時間を考慮して算出された最適な価格です。実際の料金は、交通状況、天候、道路工事、または異なるルートなどの要因により変動する場合があります。ご注意ください：予想料金は注文時点でのみ有効です。通行料や空港料金などの追加費用は予想料金に含まれていません。この見積りはあくまで予想料金であり、実際の行程料金が予想料金を上回らないことを保証するものではありません。'
          },
          costBreakdown: {
            label: '料金の内訳',
            content:
              '行程の料金は、さまざまな要因を総合的に計算して算出され、地域や配車サービス提供者によって異なる場合があります。料金計算の際、主に以下の3つの要素が考慮されます：1. 初乗り料金 2. 距離料金（走行距離） 3. 時間料金（走行時間） さらに実際の料金に影響を与える可能性のある要因：1. 動的運賃（ピーク料金など） 2. 通行料や空港料金 3. 車両の種類 4. ミニプログラムのサービス料 実際の料金が予想料金と異なる場合は、「実際の料金が予想料金を超えた場合」の解答をご参照ください。ご注意ください：電子領収書には現在料金の内訳は記載されません。行程終了時に、配車サービス提供者が算出した実際の料金をお送りします。ミニプログラムを利用することにより、表示された価格を受け入れ、差し引かれる料金が実際の行程料金であるとみなされます。実際の料金はタクシーメーターに表示される料金と異なる場合があります。'
          },
          additionalFees: {
            label: '高速料金、空港料金等の追加料金',
            content:
              'ご注意ください。空港料金、高速料金、過路料金などの追加料金は予想料金に含まれていません。これらの追加料金はすべて乗客の負担となります。ただし、ドライバーは行程終了前にこれらの費用を実際の運賃に加算する場合があります。'
          },
          cancellationFees: {
            label: '注文キャンセル料',
            content:
              'ドライバーの移動距離や時間に対する補償として、以下の2つの場合に注文をキャンセルするとキャンセル料が発生する可能性があります。1. ドライバーが注文を受け、乗車地に向けて一定時間または距離を走行した後。2. ドライバーが乗車地に到着し、一定時間以上待機した場合。この場合、ドライバーが注文をキャンセルしてもキャンセル料が発生します。キャンセル料の徴収は、配車サービス提供者が効率的に運営し、迅速な配車を維持するために役立ちます。キャンセル料は地域や配車サービス提供者によって異なる場合があります。料金が不合理であるとお考えの場合は、「カスタマーサポートに連絡」ボタンを通じてカスタマーサポートにご連絡ください。最大限サポートさせていただきます。'
          },
          actualCostHigher: {
            label: '実際の料金が予想料金を超えた場合',
            content:
              '注文前に提示される見積りはあくまで予想料金であり、実際の行程料金が予想料金を超えないことを保証するものではありません。実際の料金が予想料金を上回る可能性がある理由：1. 交通渋滞 2. 通行料や空港料金などの追加費用 3. 行程中の追加停車 4. ドライバーが別のルートを選択した場合 5. ナビゲーションやネットワークの問題 実際の料金についてご不明点がある場合は、「カスタマーサポートに連絡」ボタンを通じてカスタマーサポートにご連絡ください。可能な限りサポートいたします。'
          },
          vehicleDamage: {
            label: '車両の損傷・清掃費用',
            content:
              '乗客が車両を汚した場合、清掃費用は乗客の負担となります。このような場合、ドライバーは実際の料金に清掃費を加算する権利があります。この費用はドライバーに直接支払われ、車両の清掃に使用されます。乗客は車内での飲食を控え、車両を清潔に保つようご協力ください。'
          }
        },
        driver: {
          longerRoute: {
            label: 'ドライバーが長いルートを選択した場合',
            content:
              'ドライバーはナビの推奨に従い、最短または最速ルートを選択する権利があります。行程終了時に実際の料金が予想料金を超える場合、ドライバーが交通渋滞や道路の突発状況を避けるために長いルートを選択した可能性があります。ご希望のルートがある場合は、出発前にドライバーと相談し合意を得てください。そうすることで誤解を防ぐことができます。実際の料金が明らかに予想を超える場合は、「カスタマーサポートに連絡」ボタンを通じてカスタマーサポートにご連絡ください。できる限りサポートいたします。'
          },
          orderNotEnded: {
            label: '下車後にドライバーが注文を終了しなかった場合',
            content:
              'ドライバーは、乗客が下車した時点、またはその直後に注文を終了する必要があります。ドライバーが注文を適切に終了しなかったために、実際の料金が予想料金を大きく上回った場合は、「カスタマーサポートに連絡」ボタンを通じてカスタマーサポートにご連絡ください。できる限りサポートいたします。'
          }
        },
        other: {
          lostItems: {
            label: '遺失物',
            content:
              '遺失物の心配なお気持ちは十分理解しており、できる限りお手伝いさせていただきます。下の「カスタマーサポートに連絡」ボタンをクリックして、カスタマーサポートと確認してください。その際、以下の情報をご提供ください：1. 紛失した物品の詳細な説明 2. 見つかった場合、どこで受け取りたいか 3. ご連絡先の電話番号（発見後すぐに連絡できるように） 4. どのくらいの期間その場所に滞在する予定か 以上の情報をいただいた後、配車サービス提供者に速やかに連絡し、遺失物の回収をサポートいたします。なお、個人情報保護法によりドライバーの連絡先を提供することはできません。ご注意ください：遺失物の回収に全力を尽くしますが、行程中に紛失した物品について責任を負うことはできません。'
          },
          otherIssues: {
            label: 'その他の問題',
            content:
              'ご注文やサービスに関して他に問題やご意見がある場合は、下の「カスタマーサポートに連絡」ボタンを通じてカスタマーサポートにご連絡ください。できる限りサポートいたします。'
          }
        }
      },
      contact: 'お問い合わせ'
    }
  },
  cancelTerms: {
    title: 'キャンセルルール',
    textTitle: 'GOx日本タクシーキャンセルルール',
    content: [
      {
        title: 'キャンセル料の説明',
        content: [
          'ドライバーが注文を受けてから3分以上経過するか、乗車地点に到着した場合、注文をキャンセルすると、サプライヤーがキャンセル料を請求する場合があります。',
          '異なるサプライヤーのキャンセル料ルールに違いがある可能性があるため、具体的な料金基準については、サプライヤーが提供する情報を参照してください。'
        ]
      },
      {
        title: 'キャンセル料の用途',
        content: [
          'プラットフォームが徴収するキャンセル料は、旅行のキャンセルにより発生する空走コストをドライバーに補償し、ドライバーの権利を保護するために使用されます。'
        ]
      },
      {
        title: 'キャンセル料を支払う必要がある場合',
        content: [
          '指定された時間を過ぎて注文をキャンセルし、ドライバーに空走コストが発生した場合、補償としてキャンセル料を支払う必要があります。',
          '具体的なキャンセル料基準は、サプライヤーのルールに基づいて計算され、キャンセル時にシステムが対応する料金を表示します。'
        ]
      },
      {
        title: 'キャンセル料を支払う必要がない場合',
        content: [
          '指定された時間内に注文をキャンセルする場合、キャンセル料を支払う必要はありません。',
          {
            title:
              '以下の理由で注文をキャンセルする場合、キャンセル料が免除される場合があります：',
            content: [
              'ドライバーが積極的に注文をキャンセルする',
              'ドライバーが予定時間に乗車地点に到着しない',
              'ドライバーが乗客を拒否する、または理由なく来ない',
              'ドライバーの理由により注文が正常に進行できないその他の状況'
            ]
          },
          '上記の状況によりキャンセル料が発生した場合、カスタマーサービスに連絡して申し立てることができ、プラットフォームは確認後にキャンセル料免除処理を行います。'
        ]
      },
      {
        title: '紛争解決',
        content: [
          'キャンセル料に異議がある場合、注文がキャンセルされてから24時間以内にカスタマーサービスに連絡して申し立てることができます。',
          'プラットフォームは注文記録、ドライバーのフィードバック、関連する証拠に基づいて確認し、確認完了後に最終決定を行います。'
        ]
      }
    ],
    bottomDesc:
      'GOx日本タクシープラットフォームをお選びいただき、ありがとうございます。楽しい旅をお過ごしください！'
  },
  components: {
    confirm: {
      confirm: 'OK',
      cancel: 'キャンセル'
    },
    map: {
      locationPermission: {
        harmony: '現在地を取得できません。「設定 > プライバシーとセキュリティ > 位置情報」で位置情報サービスをオンにし、本サービスによる位置情報の利用を許可してください。',
        wechat: '現在地を取得できません。端末の「設定」で位置情報サービスをオンにし、WeChatによる位置情報の利用を許可してください。',
        ios: '現在地を取得できません。「設定 > プライバシーとセキュリティ > 位置情報サービス」で位置情報サービスをオンにし、ご利用中のブラウザによる位置情報の利用を許可してください。',
        android: '現在地を取得できません。「設定 > 位置情報」で位置情報をオンにし、ブラウザのサイト設定で本サイトによる位置情報の利用を許可してください。',
        default: '現在地を取得できません。ブラウザの設定で本サイトによる位置情報の利用を許可してください。'
      },
      locationPermissionConfirm: 'OK'
    },
    hotel: {
      back: '戻る',
      multiLanguage: 'EN/中/日/한'
    }
  },
  common: {
    noData: 'データがありません',
    copyright: '© LINKTIVITY Inc. All Rights Reserved.'
  },
  errorCode: {
    [ErrorCode.Internal]:
      'システムが混雑しています。しばらくしてからお試しください',
    [ErrorCode.Unauthorized]:
      'ログイン期限が切れました。再度ログインしてください',
    [ErrorCode.InvalidArgument]:
      '入力情報に誤りがあります。再度入力してください',
    [ErrorCode.PaymentFailed]: '支払いに失敗しました。もう一度お試しください',
    [ErrorCode.PendingPaymentExist]:
      '未完了の支払い注文があります。先に処理してください',
    [ErrorCode.PaymentNotCompleted]:
      '支払いが完了していません。支払いを続けてください',
    [ErrorCode.LoginFailed]: 'ログインに失敗しました。再度ログインしてください',
    [ErrorCode.RefundFailed]:
      '返金に失敗しました。カスタマーサービスに連絡してください',
    [ErrorCode.AccessTokenExpired]:
      'ログイン期限が切れました。再度ログインしてください',
    [ErrorCode.TaxiNotFound]:
      '利用可能な車両が見つかりません。しばらくお待ちください',
    [ErrorCode.InvalidLocation]: '無効な位置情報です。再度選択してください',
    [ErrorCode.NotCancellable]: 'この状態では注文をキャンセルできません',
    [ErrorCode.DeadlineExceeded]:
      'システムが混雑しています。しばらくしてからお試しください',
    [ErrorCode.CouponNotFound]: '該当のクーポンは存在しません',
    [ErrorCode.CouponExpired]: 'クーポンの有効期限が切れています',
    [ErrorCode.CouponAlreadyUsed]: 'このクーポンは既に使用されています',
    [ErrorCode.CouponNotApplicable]: 'このクーポンはご利用いただけません',
    [ErrorCode.CouponAlreadyRedeemed]: 'このクーポンは既に引き換え済みです',
    [ErrorCode.CouponOutOfAllotment]: 'クーポンの配布数が上限に達しました',
    [ErrorCode.CouponEventEnded]: 'クーポンイベントは終了しました',
    [ErrorCode.CouponEventNotStarted]:
      'クーポンイベントはまだ開始されていません'
  },
  firebase: {
    'auth/wrong-password': 'ログイン名またはパスワードが間違っています。',
    'auth/user-not-found': 'ログイン名またはパスワードが間違っています。',
    'auth/email-already-in-use': 'メールアドレスは既に登録されています。',
    'auth/too-many-requests':
      'ログイン試行の回数が上限を超えました。しばらくしてからもう一度お試しいただくか、パスワードをリセットしてください。'
  }
};
